import * as fabric from "fabric";

/**
 * Element Selection Mixin
 * Handles element selection, transformation, and manipulation on canvas
 */
export default {
  methods: {
    async onSelectionChange(event) {
      if (this.selectedElement?.type?.toLowerCase().includes("text")) {
        if (this.selectedElement.text.length === 0) {
          window.activeCanvas.remove(this.selectedElement);
        }
        window?.activeCanvas?.discardActiveObject();
        window?.activeCanvas?.renderAll();
        return;
      }

      this.selectedElement = event.selected[0];

      if (this.selectedElement) {
        if (this.selectedElement?.type?.toLowerCase().includes("text")) {
          // Handle text selection
        }

        this.selectedElement.on("moving", this.moveHelperElement);
        this.selectedElement.on("rotating", this.rotateHelperElement);
        this.selectedElement.on("scaling", this.onSelectedElementScaling);

        const clonedObj = await this.selectedElement.clone();
        clonedObj.set({
          top: clonedObj.top + (850 / window.activeCanvas.getWidth()) * 25,
          left: clonedObj.left + (850 / window.activeCanvas.getWidth()) * 25,
          opacity: 0,
        });
        clonedObj.canvas = null;
        this.helperElement = clonedObj;
        window.helperCanvas.add(clonedObj);
        window.helperCanvas.setActiveObject(clonedObj);

        if (this.helperElement) {
          const deleteControl = new fabric.Control({
            actionHandler: (eventData, transform, x, y) => {
              window.activeCanvas.remove(transform.target);
            },
            actionName: "delete",
          });

          this.helperElement.set("deleteControl", deleteControl);
          window.helperCanvas.renderAll();

          this.helperElement.on("moving", this.moveSelectedElement);
          this.helperElement.on("rotating", this.rotateSelectedElement);
          this.helperElement.on("scaling", this.onHelperElementScaling);
          this.helperElement.on("mousedblclick", () => {
            this.selectedElement.enterEditing();
            this.selectedElement.selectAll();
          });
        }

        this.$forceUpdate();
      }
    },

    onSelectionCleared() {
      if (this.selectedElement) {
        this.selectedElement.off("moving");
        this.selectedElement.off("rotating");
        this.selectedElement.off("scaling");
      }

      if (this.helperElement) {
        this.helperElement.off("moving");
        this.helperElement.off("rotating");
        this.helperElement.off("scaling");
      }

      window.helperCanvas.remove(this.helperElement);
      this.helperElement = null;
      this.selectedElement = null;
    },

    rotateSelectedElement() {
      this.selectedElement.off("rotating");
      this.selectedElement.rotate(this.helperElement.angle);
      window.activeCanvas.renderAll();
      this.selectedElement.on("rotating", this.rotateHelperElement);
      this.fireDebouncedModify();
    },

    rotateHelperElement() {
      this.helperElement.off("rotating");
      this.helperElement.rotate(this.selectedElement.angle);
      window.helperCanvas.renderAll();
      this.helperElement.on("rotating", this.rotateSelectedElement);
    },

    moveSelectedElement() {
      this.selectedElement.off("moving");
      this.selectedElement.set({
        top:
          this.helperElement.top - (850 / window.activeCanvas.getWidth()) * 25,
        left:
          this.helperElement.left - (850 / window.activeCanvas.getWidth()) * 25,
      });
      window.activeCanvas.setActiveObject(this.selectedElement);
      window.activeCanvas.renderAll();
      this.selectedElement.on("moving", this.moveHelperElement);
      this.fireDebouncedModify();
    },

    moveHelperElement() {
      if (this.helperElement) {
        this.helperElement.off("moving");
        this.helperElement.set({
          top:
            this.selectedElement.top +
            (850 / window.activeCanvas.getWidth()) * 25,
          left:
            this.selectedElement.left +
            (850 / window.activeCanvas.getWidth()) * 25,
        });
        window.helperCanvas.setActiveObject(this.helperElement);
        window.helperCanvas.renderAll();
        this.helperElement.on("moving", this.moveSelectedElement);
      }
    },

    onSelectedElementScaling() {
      this.helperElement.off("scaling");
      this.helperElement.set({
        scaleX: this.selectedElement.scaleX,
        scaleY: this.selectedElement.scaleY,
      });
      window.helperCanvas.setActiveObject(this.helperElement);
      window.helperCanvas.renderAll();
      this.helperElement.on("scaling", this.onHelperElementScaling);
    },

    onHelperElementScaling() {
      this.selectedElement.off("scaling");
      this.selectedElement.set({
        scaleX: this.helperElement.scaleX,
        scaleY: this.helperElement.scaleY,
      });
      window.activeCanvas.setActiveObject(this.selectedElement);
      window.activeCanvas.renderAll();
      this.selectedElement.on("scaling", this.onSelectedElementScaling);
      this.fireDebouncedModify();
    },

    onTextChange(event) {
      this.helperElement?.set({
        text: event.target.text,
      });
      window.helperCanvas?.renderAll();
    },
  },
};
